define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toggleClass = exports.removeClass = exports.addClass = exports.hasClass = exports.formatJson = exports.parseTime = exports.isValidURL = exports.isArray = exports.isExternal = exports.isValidUsername = void 0;
    var isValidUsername = function (str) { return ['admin', 'editor'].indexOf(str.trim()) >= 0; };
    exports.isValidUsername = isValidUsername;
    var isExternal = function (path) { return /^(https?:|mailto:|tel:)/.test(path); };
    exports.isExternal = isExternal;
    var isArray = function (arg) {
        if (typeof Array.isArray === 'undefined') {
            return Object.prototype.toString.call(arg) === '[object Array]';
        }
        return Array.isArray(arg);
    };
    exports.isArray = isArray;
    var isValidURL = function (url) {
        var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
        return reg.test(url);
    };
    exports.isValidURL = isValidURL;
    var parseTime = function (time, cFormat) {
        if (time === undefined || !time) {
            return null;
        }
        var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
        var date;
        var timeValue = time || new Date();
        if (typeof time === 'object') {
            date = time;
        }
        else {
            if (typeof time === 'string') {
                if (/^[0-9]+$/.test(time)) {
                    timeValue = +time;
                }
                else {
                    timeValue = time.replace(new RegExp(/-/gm), '/');
                }
            }
            if (typeof time === 'number' && time.toString().length === 10) {
                timeValue = time * 1000;
            }
            date = new Date(time);
        }
        var formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
        };
        var timeStr = format.replace(/{([ymdhisa])+}/g, function (result, key) {
            var value = formatObj[key];
            if (key === 'a') {
                return ['日', '一', '二', '三', '四', '五', '六'][value];
            }
            return value.toString().padStart(2, '0');
        });
        return timeStr;
    };
    exports.parseTime = parseTime;
    var formatJson = function (filterKeys, jsonData) {
        return jsonData.map(function (data) {
            return filterKeys.map(function (key) {
                if (key === 'timestamp') {
                    return (0, exports.parseTime)(data[key]);
                }
                else {
                    return data[key];
                }
            });
        });
    };
    exports.formatJson = formatJson;
    var hasClass = function (ele, className) {
        return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    };
    exports.hasClass = hasClass;
    var addClass = function (ele, className) {
        if (!(0, exports.hasClass)(ele, className))
            ele.className += ' ' + className;
    };
    exports.addClass = addClass;
    var removeClass = function (ele, className) {
        if ((0, exports.hasClass)(ele, className)) {
            var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
            ele.className = ele.className.replace(reg, ' ');
        }
    };
    exports.removeClass = removeClass;
    var toggleClass = function (ele, className) {
        if (!ele || !className) {
            return;
        }
        var classString = ele.className;
        var nameIndex = classString.indexOf(className);
        if (nameIndex === -1) {
            classString += '' + className;
        }
        else {
            var subStr = classString.substr(0, nameIndex);
            var subEnd = classString.substr(Number(nameIndex) + Number(className.length));
            classString = "".concat(subStr).concat(subEnd);
        }
        ele.className = classString;
    };
    exports.toggleClass = toggleClass;
});
//# sourceMappingURL=UtilsValidate.js.map